// ============================================================================
// NEKASSUR — Contenu bilingue centralisé (FR / EN).
// La version française fait référence. Les traductions anglaises sont
// informatives. Les informations réglementaires françaises restent la référence
// juridique.
// ============================================================================

export const translations = {
  fr: {
    langLabel: "FR",
    nav: {
      home: { label: "Accueil", path: "" },
      particuliers: { label: "Particuliers", path: "/particuliers" },
      professionnels: { label: "Professionnels & entreprises", path: "/professionnels-entreprises" },
      epargne: { label: "Épargne & retraite", path: "/epargne-retraite-assurance-vie" },
      frontaliers: { label: "Frontaliers", path: "/frontaliers" },
      about: { label: "À propos", path: "/a-propos" },
      conseils: { label: "Conseils", path: "/conseils" },
      contact: { label: "Contact", path: "/contact" },
    },
    cta: {
      findSolution: "Trouver ma solution",
      bookAppointment: "Prendre rendez-vous",
      contactUs: "Contactez-nous",
      discover: "Découvrir",
      studyNeed: "Étudier mon besoin",
      presentSituation: "Présenter ma situation",
      learnMore: "En savoir plus",
      appointment: "Rendez-vous",
      close: "Fermer",
      back: "Retour",
      next: "Continuer",
      send: "Envoyer ma demande",
      readMore: "Lire l'article",
      allArticles: "Tous les conseils",
    },
    header: {
      skip: "Aller au contenu principal",
      menu: "Menu",
      cabinet: "Le cabinet",
      partners: "Partenaires",
      faq: "FAQ",
    },
    footer: {
      tagline: "Courtier en assurances indépendant. Votre assurance, notre mission : trouver la solution.",
      navTitle: "Navigation",
      cabinetTitle: "Le cabinet",
      legalTitle: "Informations légales",
      contactTitle: "Contact",
      followUs: "Suivez-nous",
      newsletterTitle: "Recevoir nos conseils",
      newsletterText: "Conseils utiles et actualités, sans spam. Désinscription en un clic.",
      newsletterPlaceholder: "Votre adresse e-mail",
      newsletterConsent:
        "J'accepte de recevoir la newsletter de NEKASSUR et j'ai compris que je peux me désinscrire à tout moment.",
      newsletterButton: "S'inscrire",
      newsletterSuccess: "Merci ! Un e-mail de confirmation vient de vous être envoyé.",
      links: {
        mentions: { label: "Mentions légales", path: "/mentions-legales" },
        privacy: { label: "Politique de confidentialité", path: "/politique-confidentialite" },
        cookies: { label: "Politique de cookies", path: "/politique-cookies" },
        complaints: { label: "Réclamations & médiation", path: "/reclamations" },
        partners: { label: "Partenaires", path: "/partenaires" },
        faq: { label: "FAQ", path: "/faq" },
        cookiePrefs: "Gérer les cookies",
      },
      rights: "Tous droits réservés.",
      oriasNote: "Intermédiaire en assurances immatriculé à l'ORIAS.",
      missingData: "Information légale à compléter avant publication.",
    },
    hero: {
      eyebrow: "COURTIER EN ASSURANCES",
      h1a: "Nous cherchons plus loin",
      h1b: "pour mieux vous assurer",
      intro:
        "Des solutions adaptées aux particuliers comme aux entreprises même lorsque la situation sort des critères habituels",
      conviction: "Les situations complexes méritent une vraie réponse",
      proofs: [
        "Plus de 5 ans d'expérience",
        "Réseau multi-partenaires",
        "Particuliers & professionnels",
        "Accompagnement humain",
      ],
      cardTitle: "Situation complexe ? Parlons-en.",
      cardTags: ["Malus", "Résiliation", "Activité spécifique"],
      cardText: "Chaque dossier est étudié, présenté et défendu auprès des partenaires les plus pertinents.",
      mini: {
        title: "Trouvez votre solution en 30 secondes",
        q1: "Vous êtes…",
        q1Options: [
          { id: "particulier", label: "Particulier", profile: "Particulier" },
          { id: "pro", label: "Professionnel", profile: "Indépendant" },
          { id: "frontalier", label: "Frontalier", profile: "Frontalier" },
        ],
        q2: "Votre situation…",
        q2Options: [
          { id: "standard", label: "Recherche standard", need: "Autre besoin" },
          { id: "malus", label: "Malus ou résiliation", need: "Situation complexe ou refus antérieur" },
          { id: "complexe", label: "Profil complexe", need: "Situation complexe ou refus antérieur" },
        ],
        cta: "Voir ma solution",
      },
    },
    orienteur: {
      title: "Ce que vous souhaitez protéger",
      intro: "Choisissez un univers pour découvrir les solutions adaptées à votre situation.",
      options: [
        { id: "perso", label: "Ma vie personnelle" },
        { id: "pro", label: "Mon activité professionnelle" },
        { id: "avenir", label: "Mon avenir et mon patrimoine" },
      ],
    },
    diff: {
      eyebrow: "LA DIFFÉRENCE NEKASSUR",
      title: "Nous ne nous arrêtons pas au premier non",
      text: "Certains profils demandent plus qu'un devis automatique : comprendre le passif, présenter correctement le dossier et interroger les partenaires réellement adaptés. C'est précisément là que nous nous engageons.",
      pills: [
        "Conducteur malussé ou résilié",
        "Sinistralité importante",
        "Profession ou activité spécifique",
        "Entreprise nouvellement créée",
        "Antécédents ou situation atypique",
        "Garantie rarement proposée en direct",
      ],
    },
    products: {
      title: "Des solutions pour chaque besoin d'assurance.",
      intro: "Deux univers, un même engagement : chercher activement la bonne solution.",
      particuliersTitle: "Particuliers",
      proTitle: "Professionnels & entreprises",
      viewAll: "Voir toutes les solutions",
    },
    method: {
      title: "Simple pour vous\nRigoureux pour nous",
      steps: [
        { n: "01", title: "Vous nous expliquez votre situation", text: "Un échange clair, sans jargon, pour comprendre votre besoin réel." },
        { n: "02", title: "Nous analysons réellement votre besoin", text: "Étude du profil, des antécédents et des priorités de couverture." },
        { n: "03", title: "Nous interrogeons les solutions adaptées", text: "Nous sollicitons les partenaires les plus pertinents pour votre dossier." },
        { n: "04", title: "Nous vous accompagnons dans la durée", text: "Après la souscription, NEKASSUR reste votre interlocuteur." },
      ],
      note: "Après la souscription, NEKASSUR reste l'interlocuteur du client, dans les limites de ses missions et conventions.",
    },
    frontaliersTeaser: {
      eyebrow: "EXPERTISE COMPLÉMENTAIRE",
      title: "Des solutions pensées pour votre vie entre deux pays",
      text: "NEKASSUR accompagne les résidents français frontaliers sur leurs assurances personnelles et professionnelles, leur protection, leur épargne, le PER et les solutions d'assurance-vie éligibles.",
      cta: "Découvrir l'accompagnement frontalier",
    },
    founder: {
      eyebrow: "LE FONDATEUR",
      role: "Fondateur — Courtier en assurances",
      title: "Un cabinet créé pour écouter comprendre et chercher davantage",
      quote: "Chaque dossier mérite d'être compris avant d'être jugé",
      text: "Après un cursus supérieur entièrement consacré à l'assurance et plus de cinq années d'expérience acquises sur le terrain, Yanis Nekhla a exercé plusieurs responsabilités opérationnelles, dont trois années à la tête d'un cabinet. Son expérience en France et en Suisse lui a permis d'observer une réalité simple : trop de clients restent sans explication claire ou sans recherche approfondie dès que leur situation sort des critères habituels. Il crée NEKASSUR avec une conviction : chaque dossier mérite d'être écouté, compris et présenté aux partenaires les plus pertinents.",
      badge: "Formation supérieure spécialisée en assurance",
      cta: "Découvrir le parcours de Yanis Nekhla",
    },
    partners: {
      eyebrow: "NOTRE RÉSEAU",
      title: "Un réseau qui élargit le champ des solutions",
      intro: "Plus notre réseau est large, plus nous pouvons chercher une solution adaptée à votre situation.",
      networkLabel: "partenariats actifs",
      note: "Ce réseau nous permet d'interroger des solutions adaptées à des besoins variés. NEKASSUR ne prétend pas comparer l'intégralité du marché.",
      pendingLogo: "Logo à valider",
    },
    reviews: {
      eyebrow: "EXPÉRIENCES CLIENTS",
      title: "Des situations réelles. Un accompagnement qui fait la différence.",
      draftNote: "Section en préparation : les avis authentiques et vérifiés seront publiés dès qu'ils seront disponibles. Aucun avis n'est inventé.",
      verified: "Avis vérifié",
      via: "via",
    },
    conseils: {
      eyebrow: "CONSEILS & ACTUALITÉS",
      title: "Comprendre pour mieux décider",
      pageTitle: "Comprendre l'assurance pour décider avec confiance",
      intro: "Conseils pédagogiques, changements utiles et actualités du cabinet.",
      categoriesTitle: "Catégories",
      categories: {
        particuliers: "Particuliers",
        professionnels: "Professionnels",
        complexes: "Profils complexes",
        epargne: "Épargne & retraite",
        frontaliers: "Frontaliers",
        actualites: "Actualités & offres partenaires",
      },
      readingTime: "min de lecture",
      published: "Publié le",
      by: "Par",
      related: "À lire également",
      offerConditions: "Offre soumise à conditions. Durée et conditions complètes disponibles auprès du cabinet.",
    },
    faq: {
      eyebrow: "QUESTIONS FRÉQUENTES",
      title: "Les réponses à vos questions",
      items: [
        { q: "Pourquoi passer par un courtier en assurances ?", a: "Un courtier vous conseille de façon indépendante, interroge plusieurs partenaires et présente votre dossier de manière argumentée. Vous gagnez du temps et bénéficiez d'un interlocuteur unique qui défend votre intérêt." },
        { q: "NEKASSUR compare-t-il plusieurs solutions ?", a: "Oui, nous interrogeons plusieurs partenaires afin de rechercher une couverture adaptée. Nous ne prétendons toutefois pas comparer l'intégralité du marché." },
        { q: "Pouvez-vous étudier un dossier après une résiliation ou un malus ?", a: "Oui. Ces profils demandent une véritable étude : nous comprenons le passif, présentons correctement le dossier et sollicitons les partenaires adaptés. Nous ne garantissons jamais une acceptation, mais nous cherchons activement une solution." },
        { q: "Travaillez-vous avec les particuliers et les professionnels ?", a: "Oui. NEKASSUR accompagne aussi bien les particuliers que les indépendants, dirigeants, professionnels et entreprises." },
        { q: "Intervenez-vous partout en France ?", a: "Oui, notre zone d'intervention principale est la France entière, avec un ancrage local à Nancy et dans le Grand Est." },
        { q: "Accompagnez-vous les frontaliers suisses et luxembourgeois ?", a: "Oui, à titre d'expertise complémentaire, pour les résidents français travaillant en Suisse ou au Luxembourg, sur leurs assurances personnelles et professionnelles, leur protection et leur épargne éligible." },
        { q: "Comment se déroule le premier rendez-vous ?", a: "Un échange d'écoute : vous exposez votre situation, nous clarifions le besoin et vous expliquons comment nous pouvons avancer. Sans jargon." },
        { q: "Le rendez-vous est-il sans engagement ?", a: "Oui, le premier échange est sans engagement." },
        { q: "Comment mes données sont-elles utilisées ?", a: "Vos données servent uniquement à traiter votre demande. Elles sont protégées et ne sont jamais revendues. Consultez notre politique de confidentialité pour le détail des finalités, durées et droits." },
      ],
    },
    finalCta: {
      title: "Votre situation mérite une vraie réponse",
      text: "Expliquez-nous votre besoin. Nous vous dirons clairement comment nous pouvons avancer.",
    },
    servicePage: {
      breadcrumbHome: "Accueil",
      profilesTitle: "À qui s'adresse cette assurance ?",
      risksTitle: "Ce que nous cherchons à couvrir",
      complexTitle: "Situations plus complexes que nous pouvons étudier",
      methodTitle: "Notre méthode",
      prepareTitle: "Ce que vous pouvez préparer pour le rendez-vous",
      prepareNote: "Aucun document ni donnée médicale détaillée ne vous est demandé sur ce site.",
      faqTitle: "Questions fréquentes",
      relatedTitle: "Autres solutions",
      ctaTitle: "Étudions votre situation ensemble.",
      ctaText: "Un échange clair pour comprendre votre besoin et rechercher la bonne solution.",
    },
    hubs: {
      particuliers: {
        eyebrow: "PARTICULIERS",
        title: "Protéger votre quotidien vos proches et vos projets",
        intro: "De l'auto à l'assurance-vie, nous recherchons des solutions adaptées à votre quotidien — y compris pour les profils auto malussés, résiliés ou fortement sinistrés.",
        complexTitle: "Profil auto malussé, résilié ou sinistré ?",
        complexText: "Nous étudions réellement votre dossier plutôt que de le refuser automatiquement.",
      },
      professionnels: {
        eyebrow: "PROFESSIONNELS & ENTREPRISES",
        title: "Protéger votre activité vos équipes et votre avenir",
        intro: "Indépendants, artisans, commerçants, TPE/PME : nous recherchons des couvertures adaptées à votre métier et à vos obligations.",
        segmentsTitle: "Quel est votre profil ?",
        segments: [
          "Indépendants & professions libérales",
          "Artisans & BTP",
          "Commerçants",
          "TPE / PME",
          "Entreprises avec salariés",
        ],
      },
      epargne: {
        eyebrow: "ÉPARGNE, RETRAITE & ASSURANCE-VIE",
        title: "Préparer l'avenir et transmettre sereinement",
        intro: "Assurance-vie, Plan d'Épargne Retraite, protection et transmission : un accompagnement patrimonial lié aux solutions assurantielles.",
        riskNote: "Certains supports d'investissement présentent un risque de perte en capital. Les avantages fiscaux dépendent de votre situation et de la réglementation en vigueur. Aucun rendement n'est garanti.",
      },
    },
    frontaliersPage: {
      eyebrow: "FRONTALIERS SUISSE & LUXEMBOURG",
      title: "Des solutions pensées pour votre vie entre deux pays",
      intro: "NEKASSUR vous accompagne, en expertise complémentaire, sur vos assurances personnelles et professionnelles, votre protection, votre épargne, le PER et les solutions d'assurance-vie éligibles à votre situation de résident français.",
      disclaimer: "NEKASSUR est un cabinet français et n'est pas un cabinet suisse ou luxembourgeois. Cette page s'adresse uniquement aux personnes résidant en France.",
      blocksTitle: "Notre accompagnement",
      blocks: [
        { title: "Assurances personnelles", text: "Prévoyance, santé complémentaire et protection adaptées à votre statut de résident frontalier." },
        { title: "Assurances professionnelles", text: "Pour les indépendants et dirigeants concernés par une activité de part et d'autre de la frontière." },
        { title: "Épargne, PER & assurance-vie", text: "Solutions d'épargne et de préparation de la retraite éligibles à votre résidence fiscale française." },
        { title: "Protection & transmission", text: "Anticiper la protection de vos proches et la transmission de votre patrimoine." },
      ],
      comparison: {
        title: "Suisse ou Luxembourg : ce qui change pour vous",
        intro: "Selon votre pays de travail, certains sujets d'assurance s'abordent différemment. Voici les grandes lignes, à approfondir ensemble selon votre situation.",
        suisseLabel: "Frontalier en Suisse",
        luxLabel: "Frontalier au Luxembourg",
        topicLabel: "Thème",
        rows: [
          {
            topic: "Assurance maladie",
            suisse: "Assurance de base obligatoire (LAMal), avec un droit d'option permettant, selon les cas, de choisir une couverture côté France. Le choix mérite d'être étudié avec attention.",
            lux: "Affiliation à la sécurité sociale luxembourgeoise ; une complémentaire santé côté France est souvent pertinente pour compléter les remboursements.",
          },
          {
            topic: "Prévoyance & retraite",
            suisse: "Système de prévoyance suisse (piliers). La coordination avec la retraite française et l'optimisation de l'épargne se préparent en amont.",
            lux: "Régime de retraite luxembourgeois coordonné avec la France ; l'anticipation d'un complément d'épargne reste recommandée.",
          },
          {
            topic: "Épargne & assurance-vie",
            suisse: "Solutions françaises d'épargne, de PER et d'assurance-vie éligibles à votre résidence fiscale française.",
            lux: "Mêmes solutions françaises éligibles ; l'allocation se construit selon vos objectifs et votre horizon.",
          },
          {
            topic: "Notre accompagnement",
            suisse: "Étude personnalisée de vos couvertures, sans vous vendre un produit suisse que nous ne serions pas habilités à distribuer.",
            lux: "Étude personnalisée identique, centrée sur vos assurances et votre épargne côté résidence française.",
          },
        ],
        note: "Ces informations sont générales et ne constituent pas un conseil individualisé. Les règles applicables dépendent de votre situation personnelle, de votre pays de travail et de la réglementation en vigueur. Chaque point est à valider au cas par cas lors de notre échange.",
      },
    },
    about: {
      eyebrow: "À PROPOS",
      title: "Un cabinet né d'une conviction forte",
      conviction: "Trop de clients restent sans conseil clair ni recherche approfondie dès que leur dossier sort des critères standards. NEKASSUR existe pour changer cela.",
      journeyTitle: "Le parcours de Yanis Nekhla",
      journey: [
        { title: "Une formation supérieure spécialisée en assurance", text: "Un cursus complet entièrement consacré aux métiers de l'assurance." },
        { title: "L'apprentissage du métier sur le terrain", text: "Un parcours professionnalisant réalisé en alternance, au contact direct des clients et des dossiers." },
        { title: "Trois années à la tête d'un cabinet", text: "Des responsabilités opérationnelles complètes : conseil, gestion, développement et accompagnement." },
        { title: "Une expérience française et suisse", text: "Le courtage en Suisse a affiné sa compréhension des situations complexes et des attentes des clients." },
        { title: "La création de NEKASSUR en avril 2026", text: "Une SARL indépendante, à Nancy, pour apporter plus d'écoute, d'explications et de solutions." },
      ],
      valuesTitle: "Nos valeurs",
      founderRole: "Fondateur — Courtier en assurances",
      values: ["Écoute", "Clarté", "Disponibilité", "Persévérance", "Responsabilité", "Suivi"],
      ambitionTitle: "Notre ambition",
      ambition: "Construire, depuis Nancy, une référence du courtage capable d'accompagner des clients partout en France.",
      teamTitle: "Une équipe qui grandit",
      teamText: "NEKASSUR prépare l'accueil de nouveaux collaborateurs et d'un alternant. Cet espace présentera l'équipe à mesure qu'elle se constitue.",
    },
    contact: {
      eyebrow: "CONTACT",
      title: "Parlons de votre situation",
      intro: "Expliquez-nous votre besoin : nous vous dirons clairement comment nous pouvons avancer. Premier échange sans engagement.",
      infoTitle: "Coordonnées",
      phoneLabel: "Téléphone",
      emailLabel: "E-mail",
      addressLabel: "Adresse",
      hoursLabel: "Disponibilités",
      hours: "Sur rendez-vous, du lundi au samedi.",
      orBook: "Ou prenez directement rendez-vous en ligne.",
      toFill: "à compléter",
    },
    form: {
      title: "Trouvons votre solution",
      subtitle: "Trois étapes rapides. Aucun document ni donnée médicale ne vous est demandé.",
      step: "Étape",
      of: "sur",
      step1Title: "Votre profil",
      step2Title: "Votre besoin",
      step3Title: "Vos coordonnées",
      profiles: [
        { id: "particulier", label: "Particulier" },
        { id: "independant", label: "Indépendant" },
        { id: "dirigeant", label: "Dirigeant" },
        { id: "entreprise", label: "Entreprise" },
        { id: "frontalier", label: "Frontalier" },
      ],
      needs: [
        "Assurance auto",
        "Assurance habitation",
        "Mutuelle santé",
        "Assurance emprunteur",
        "Prévoyance",
        "Assurance-vie / PER",
        "RC professionnelle",
        "Multirisque professionnelle",
        "Assurance décennale",
        "Flotte automobile",
        "Assurances collectives",
        "Garantie financière",
        "Situation complexe ou refus antérieur",
        "Autre besoin",
      ],
      firstName: "Prénom",
      lastName: "Nom",
      postalCode: "Code postal",
      email: "E-mail",
      phone: "Téléphone",
      contactPref: "Préférence de contact",
      contactPrefOptions: [
        { id: "email", label: "E-mail" },
        { id: "phone", label: "Téléphone" },
        { id: "whatsapp", label: "WhatsApp" },
      ],
      message: "Votre message (facultatif)",
      messagePlaceholder: "Décrivez brièvement votre situation…",
      consent:
        "J'accepte que NEKASSUR utilise mes données pour traiter ma demande de contact.",
      newsletter:
        "Je souhaite aussi recevoir les conseils et actualités de NEKASSUR (facultatif).",
      rgpd:
        "Vos données sont utilisées uniquement pour traiter votre demande. Elles ne sont jamais revendues.",
      privacyLink: "Voir la politique de confidentialité",
      required: "Ce champ est requis.",
      invalidEmail: "Adresse e-mail invalide.",
      consentRequired: "Merci de cocher cette case pour être recontacté.",
      selectProfile: "Sélectionnez un profil pour continuer.",
      selectNeed: "Sélectionnez un besoin pour continuer.",
      submitting: "Envoi en cours…",
      successTitle: "Demande envoyée !",
      successText: "Merci. Nous revenons vers vous rapidement pour étudier votre situation.",
      errorGeneric: "Une erreur est survenue. Merci de réessayer.",
    },
    cookies: {
      title: "Nous respectons votre vie privée",
      text: "Nous utilisons des cookies nécessaires au fonctionnement du site et, avec votre accord, des cookies de mesure d'audience et de marketing. Aucun traceur non essentiel n'est déposé sans votre consentement.",
      acceptAll: "Tout accepter",
      rejectAll: "Tout refuser",
      customize: "Personnaliser",
      save: "Enregistrer mes choix",
      necessary: "Nécessaires",
      necessaryDesc: "Indispensables au fonctionnement du site. Toujours actifs.",
      analytics: "Mesure d'audience",
      analyticsDesc: "Nous aident à comprendre l'usage du site de façon anonyme.",
      marketing: "Marketing",
      marketingDesc: "Permettent des contenus et mesures publicitaires.",
      always: "Toujours actif",
      policyLink: "Politique de cookies",
    },
    calendly: {
      title: "Prendre rendez-vous",
      text: "Choisissez un créneau qui vous convient. Premier échange sans engagement.",
      notConfigured: "La prise de rendez-vous en ligne sera bientôt disponible. En attendant, contactez-nous directement.",
      fallback: "Ouvrir dans une nouvelle fenêtre",
      needConsent: "Le calendrier de réservation utilise un service tiers (Calendly). Autorisez les cookies marketing pour l'afficher ici, ou ouvrez-le dans une nouvelle fenêtre.",
      allowAndLoad: "Autoriser et afficher",
    },
    whatsapp: {
      label: "Contacter NEKASSUR sur WhatsApp",
      prefill: "Bonjour NEKASSUR, je souhaite échanger au sujet de mon assurance.",
      notConfigured: "Numéro WhatsApp à configurer.",
    },
    notFound: {
      title: "Page introuvable",
      text: "La page que vous cherchez n'existe pas ou a été déplacée.",
      cta: "Retour à l'accueil",
      suggestionsTitle: "Peut-être cherchiez-vous :",
    },
    legalCommon: {
      lastUpdate: "Dernière mise à jour",
      toComplete: "À COMPLÉTER",
      toCompleteNote: "Cette information doit être renseignée avant la mise en production.",
    },
  },

  // ==========================================================================
  en: {
    langLabel: "EN",
    nav: {
      home: { label: "Home", path: "" },
      particuliers: { label: "Individuals", path: "/particuliers" },
      professionnels: { label: "Professionals & businesses", path: "/professionnels-entreprises" },
      epargne: { label: "Savings & retirement", path: "/epargne-retraite-assurance-vie" },
      frontaliers: { label: "Cross-border workers", path: "/frontaliers" },
      about: { label: "About", path: "/a-propos" },
      conseils: { label: "Insights", path: "/conseils" },
      contact: { label: "Contact", path: "/contact" },
    },
    cta: {
      findSolution: "Find my solution",
      bookAppointment: "Book an appointment",
      contactUs: "Contact us",
      discover: "Discover",
      studyNeed: "Assess my need",
      presentSituation: "Present my situation",
      learnMore: "Learn more",
      appointment: "Appointment",
      close: "Close",
      back: "Back",
      next: "Continue",
      send: "Send my request",
      readMore: "Read article",
      allArticles: "All insights",
    },
    header: { skip: "Skip to main content", menu: "Menu", cabinet: "The firm", partners: "Partners", faq: "FAQ" },
    footer: {
      tagline: "Independent insurance broker. Your insurance, our mission: finding the solution.",
      navTitle: "Navigation",
      cabinetTitle: "The firm",
      legalTitle: "Legal information",
      contactTitle: "Contact",
      followUs: "Follow us",
      newsletterTitle: "Get our insights",
      newsletterText: "Useful tips and news, no spam. Unsubscribe in one click.",
      newsletterPlaceholder: "Your email address",
      newsletterConsent: "I agree to receive the NEKASSUR newsletter and understand I can unsubscribe at any time.",
      newsletterButton: "Subscribe",
      newsletterSuccess: "Thank you! A confirmation email has just been sent to you.",
      links: {
        mentions: { label: "Legal notice", path: "/mentions-legales" },
        privacy: { label: "Privacy policy", path: "/politique-confidentialite" },
        cookies: { label: "Cookie policy", path: "/politique-cookies" },
        complaints: { label: "Complaints & mediation", path: "/reclamations" },
        partners: { label: "Partners", path: "/partenaires" },
        faq: { label: "FAQ", path: "/faq" },
        cookiePrefs: "Manage cookies",
      },
      rights: "All rights reserved.",
      oriasNote: "Insurance intermediary registered with ORIAS.",
      missingData: "Legal information to be completed before publication.",
    },
    hero: {
      eyebrow: "INSURANCE BROKER",
      h1a: "We go further",
      h1b: "to find the right cover for you",
      intro:
        "Solutions for individuals and businesses even when the situation falls outside standard criteria",
      conviction: "Complex situations deserve a real answer",
      proofs: ["5+ years of experience", "Multi-partner network", "Individuals & businesses", "A human approach"],
      cardTitle: "A complex situation? Let's talk.",
      cardTags: ["Penalised", "Cancelled policy", "Specific activity"],
      cardText: "Every case is studied, presented and defended with the most relevant partners.",
      mini: {
        title: "Find your solution in 30 seconds",
        q1: "You are…",
        q1Options: [
          { id: "particulier", label: "Individual", profile: "Individual" },
          { id: "pro", label: "Professional", profile: "Self-employed" },
          { id: "frontalier", label: "Cross-border worker", profile: "Cross-border worker" },
        ],
        q2: "Your situation…",
        q2Options: [
          { id: "standard", label: "Standard search", need: "Other need" },
          { id: "malus", label: "Penalty or cancellation", need: "Complex situation or prior refusal" },
          { id: "complexe", label: "Complex profile", need: "Complex situation or prior refusal" },
        ],
        cta: "See my solution",
      },
    },
    orienteur: {
      title: "What you want to protect",
      intro: "Choose a world to discover solutions tailored to your situation.",
      options: [
        { id: "perso", label: "My personal life" },
        { id: "pro", label: "My professional activity" },
        { id: "avenir", label: "My future and assets" },
      ],
    },
    diff: {
      eyebrow: "THE NEKASSUR DIFFERENCE",
      title: "We don't stop at the first no",
      text: "Some profiles need more than an automated quote: understanding the history, presenting the case properly and reaching out to genuinely suitable partners. That is exactly where we commit.",
      pills: [
        "Penalised or cancelled driver",
        "High claims history",
        "Specific profession or activity",
        "Newly created business",
        "Prior history or atypical situation",
        "Cover rarely offered directly",
      ],
    },
    products: {
      title: "Solutions for every insurance need.",
      intro: "Two worlds, one commitment: actively searching for the right solution.",
      particuliersTitle: "Individuals",
      proTitle: "Professionals & businesses",
      viewAll: "See all solutions",
    },
    method: {
      title: "Simple for you\nRigorous for us",
      steps: [
        { n: "01", title: "You explain your situation", text: "A clear conversation, no jargon, to understand your real need." },
        { n: "02", title: "We genuinely assess your need", text: "Review of your profile, history and coverage priorities." },
        { n: "03", title: "We reach out to suitable solutions", text: "We contact the partners most relevant to your case." },
        { n: "04", title: "We support you over time", text: "After subscription, NEKASSUR remains your point of contact." },
      ],
      note: "After subscription, NEKASSUR remains the client's point of contact, within the limits of its assignments and agreements.",
    },
    frontaliersTeaser: {
      eyebrow: "COMPLEMENTARY EXPERTISE",
      title: "Solutions designed for your life between two countries",
      text: "NEKASSUR supports French cross-border residents on their personal and professional insurance, protection, savings, retirement plans (PER) and eligible life-insurance solutions.",
      cta: "Discover cross-border support",
    },
    founder: {
      eyebrow: "THE FOUNDER",
      role: "Founder — Insurance broker",
      title: "A firm built to listen, understand and search further",
      quote: "Every case deserves to be understood before it is judged",
      text: "After a full higher education entirely dedicated to insurance and more than five years of hands-on experience, Yanis Nekhla held several operational roles, including three years leading a firm. His experience in France and Switzerland revealed a simple reality: too many clients are left without a clear explanation or a thorough search as soon as their situation falls outside the usual criteria. He founded NEKASSUR with one conviction: every case deserves to be heard, understood and presented to the most relevant partners.",
      badge: "Specialised higher education in insurance",
      cta: "Discover Yanis Nekhla's journey",
    },
    partners: {
      eyebrow: "OUR NETWORK",
      title: "A network that widens the range of solutions",
      intro: "The broader our network, the better we can search for a solution suited to your situation.",
      networkLabel: "active partnerships",
      note: "This network lets us reach out to solutions suited to a variety of needs. NEKASSUR does not claim to compare the entire market.",
      pendingLogo: "Logo pending approval",
    },
    reviews: {
      eyebrow: "CLIENT EXPERIENCES",
      title: "Real situations. Support that makes the difference.",
      draftNote: "Section in preparation: authentic, verified reviews will be published as soon as they are available. No review is fabricated.",
      verified: "Verified review",
      via: "via",
    },
    conseils: {
      eyebrow: "INSIGHTS & NEWS",
      title: "Understand to decide better",
      pageTitle: "Understanding insurance to decide with confidence",
      intro: "Educational tips, useful changes and firm news.",
      categoriesTitle: "Categories",
      categories: {
        particuliers: "Individuals",
        professionnels: "Professionals",
        complexes: "Complex profiles",
        epargne: "Savings & retirement",
        frontaliers: "Cross-border",
        actualites: "News & partner offers",
      },
      readingTime: "min read",
      published: "Published on",
      by: "By",
      related: "Read also",
      offerConditions: "Offer subject to conditions. Full terms and duration available from the firm.",
    },
    faq: {
      eyebrow: "FREQUENTLY ASKED QUESTIONS",
      title: "The answers to your questions",
      items: [
        { q: "Why use an insurance broker?", a: "A broker advises you independently, reaches out to several partners and presents your case with strong arguments. You save time and gain a single point of contact who defends your interest." },
        { q: "Does NEKASSUR compare several solutions?", a: "Yes, we reach out to several partners to find suitable cover. However, we do not claim to compare the entire market." },
        { q: "Can you study a case after a cancellation or a penalty?", a: "Yes. These profiles require genuine study: we understand the history, present the case correctly and contact suitable partners. We never guarantee acceptance, but we actively search for a solution." },
        { q: "Do you work with both individuals and professionals?", a: "Yes. NEKASSUR supports individuals as well as self-employed people, company directors, professionals and businesses." },
        { q: "Do you operate across France?", a: "Yes, our main area of operation is the whole of France, with local roots in Nancy and the Grand Est region." },
        { q: "Do you support Swiss and Luxembourg cross-border workers?", a: "Yes, as complementary expertise, for French residents working in Switzerland or Luxembourg, on their personal and professional insurance, protection and eligible savings." },
        { q: "How does the first appointment work?", a: "A listening conversation: you describe your situation, we clarify the need and explain how we can move forward. No jargon." },
        { q: "Is the appointment without commitment?", a: "Yes, the first conversation is without commitment." },
        { q: "How is my data used?", a: "Your data is used solely to handle your request. It is protected and never resold. See our privacy policy for details on purposes, retention and rights." },
      ],
    },
    finalCta: {
      title: "Your situation deserves a real answer",
      text: "Tell us about your need. We'll clearly tell you how we can move forward.",
    },
    servicePage: {
      breadcrumbHome: "Home",
      profilesTitle: "Who is this insurance for?",
      risksTitle: "What we aim to cover",
      complexTitle: "More complex situations we can study",
      methodTitle: "Our method",
      prepareTitle: "What you can prepare for the appointment",
      prepareNote: "No documents or detailed medical data are requested on this website.",
      faqTitle: "Frequently asked questions",
      relatedTitle: "Other solutions",
      ctaTitle: "Let's study your situation together.",
      ctaText: "A clear conversation to understand your need and search for the right solution.",
    },
    hubs: {
      particuliers: {
        eyebrow: "INDIVIDUALS",
        title: "Protecting your daily life, your loved ones and your plans",
        intro: "From car to life insurance, we search for solutions suited to your daily life — including for penalised, cancelled or heavily-claimed car profiles.",
        complexTitle: "Penalised, cancelled or claimed car profile?",
        complexText: "We genuinely study your case rather than refusing it automatically.",
      },
      professionnels: {
        eyebrow: "PROFESSIONALS & BUSINESSES",
        title: "Protecting your activity, your teams and your future",
        intro: "Self-employed, craftspeople, retailers, small and medium businesses: we search for cover suited to your profession and obligations.",
        segmentsTitle: "What is your profile?",
        segments: ["Self-employed & liberal professions", "Craftspeople & construction", "Retailers", "Small & medium businesses", "Businesses with employees"],
      },
      epargne: {
        eyebrow: "SAVINGS, RETIREMENT & LIFE INSURANCE",
        title: "Preparing the future and passing on with peace of mind",
        intro: "Life insurance, retirement savings plan (PER), protection and transmission: wealth support linked to insurance solutions.",
        riskNote: "Some investment supports carry a risk of capital loss. Tax benefits depend on your situation and current regulations. No return is guaranteed.",
      },
    },
    frontaliersPage: {
      eyebrow: "SWISS & LUXEMBOURG CROSS-BORDER WORKERS",
      title: "Solutions designed for your life between two countries",
      intro: "NEKASSUR supports you, as complementary expertise, on your personal and professional insurance, protection, savings, retirement plan (PER) and life-insurance solutions eligible for your situation as a French resident.",
      disclaimer: "NEKASSUR is a French firm and is not a Swiss or Luxembourg firm. This page is intended only for people residing in France.",
      blocksTitle: "Our support",
      blocks: [
        { title: "Personal insurance", text: "Protection, complementary health and cover suited to your cross-border resident status." },
        { title: "Professional insurance", text: "For self-employed people and directors with activity on both sides of the border." },
        { title: "Savings, PER & life insurance", text: "Savings and retirement solutions eligible for your French tax residence." },
        { title: "Protection & transmission", text: "Anticipate protecting your loved ones and passing on your assets." },
      ],
      comparison: {
        title: "Switzerland or Luxembourg: what changes for you",
        intro: "Depending on your country of work, some insurance topics are approached differently. Here are the broad lines, to explore together based on your situation.",
        suisseLabel: "Cross-border worker in Switzerland",
        luxLabel: "Cross-border worker in Luxembourg",
        topicLabel: "Topic",
        rows: [
          {
            topic: "Health insurance",
            suisse: "Mandatory basic insurance (LAMal), with an option that may, in some cases, allow you to choose cover on the French side. This choice deserves careful study.",
            lux: "Affiliation with Luxembourg social security; complementary health cover on the French side is often relevant to top up reimbursements.",
          },
          {
            topic: "Protection & retirement",
            suisse: "Swiss pension system (pillars). Coordination with the French pension and savings optimisation are best prepared in advance.",
            lux: "Luxembourg pension scheme coordinated with France; anticipating additional savings remains recommended.",
          },
          {
            topic: "Savings & life insurance",
            suisse: "French savings, PER and life-insurance solutions eligible for your French tax residence.",
            lux: "The same eligible French solutions; the allocation is built around your goals and horizon.",
          },
          {
            topic: "Our support",
            suisse: "A personalised review of your cover, without selling you a Swiss product we would not be authorised to distribute.",
            lux: "The same personalised review, focused on your insurance and savings on the French residence side.",
          },
        ],
        note: "This information is general and does not constitute individual advice. The applicable rules depend on your personal situation, your country of work and current regulations. Each point is to be validated case by case during our conversation.",
      },
    },
    about: {
      eyebrow: "ABOUT",
      title: "A firm born from a strong conviction",
      conviction: "Too many clients are left without clear advice or a thorough search as soon as their case falls outside standard criteria. NEKASSUR exists to change that.",
      journeyTitle: "Yanis Nekhla's journey",
      journey: [
        { title: "Specialised higher education in insurance", text: "A full curriculum entirely dedicated to the insurance professions." },
        { title: "Learning the trade in the field", text: "A work-study path in direct contact with clients and cases." },
        { title: "Three years leading a firm", text: "Full operational responsibilities: advice, management, development and support." },
        { title: "French and Swiss experience", text: "Brokerage in Switzerland refined his understanding of complex situations and client expectations." },
        { title: "Founding NEKASSUR in April 2026", text: "An independent company in Nancy, to bring more listening, explanation and solutions." },
      ],
      valuesTitle: "Our values",
      founderRole: "Founder — Insurance broker",
      values: ["Listening", "Clarity", "Availability", "Perseverance", "Responsibility", "Follow-up"],
      ambitionTitle: "Our ambition",
      ambition: "To build, from Nancy, a brokerage reference able to support clients throughout France.",
      teamTitle: "A growing team",
      teamText: "NEKASSUR is preparing to welcome new team members and an apprentice. This space will introduce the team as it grows.",
    },
    contact: {
      eyebrow: "CONTACT",
      title: "Let's talk about your situation",
      intro: "Tell us about your need: we'll clearly explain how we can move forward. First conversation without commitment.",
      infoTitle: "Contact details",
      phoneLabel: "Phone",
      emailLabel: "Email",
      addressLabel: "Address",
      hoursLabel: "Availability",
      hours: "By appointment, Monday to Saturday.",
      orBook: "Or book an appointment online directly.",
      toFill: "to be completed",
    },
    form: {
      title: "Let's find your solution",
      subtitle: "Three quick steps. No documents or medical data are requested.",
      step: "Step",
      of: "of",
      step1Title: "Your profile",
      step2Title: "Your need",
      step3Title: "Your details",
      profiles: [
        { id: "particulier", label: "Individual" },
        { id: "independant", label: "Self-employed" },
        { id: "dirigeant", label: "Company director" },
        { id: "entreprise", label: "Business" },
        { id: "frontalier", label: "Cross-border worker" },
      ],
      needs: [
        "Car insurance",
        "Home insurance",
        "Health cover",
        "Loan insurance",
        "Personal protection",
        "Life insurance / PER",
        "Professional liability",
        "Professional multi-risk",
        "Decennial insurance",
        "Vehicle fleet",
        "Group insurance",
        "Financial guarantee",
        "Complex situation or prior refusal",
        "Other need",
      ],
      firstName: "First name",
      lastName: "Last name",
      postalCode: "Postal code",
      email: "Email",
      phone: "Phone",
      contactPref: "Contact preference",
      contactPrefOptions: [
        { id: "email", label: "Email" },
        { id: "phone", label: "Phone" },
        { id: "whatsapp", label: "WhatsApp" },
      ],
      message: "Your message (optional)",
      messagePlaceholder: "Briefly describe your situation…",
      consent: "I agree that NEKASSUR may use my data to handle my contact request.",
      newsletter: "I would also like to receive NEKASSUR insights and news (optional).",
      rgpd: "Your data is used solely to handle your request. It is never resold.",
      privacyLink: "See the privacy policy",
      required: "This field is required.",
      invalidEmail: "Invalid email address.",
      consentRequired: "Please tick this box to be contacted.",
      selectProfile: "Select a profile to continue.",
      selectNeed: "Select a need to continue.",
      submitting: "Sending…",
      successTitle: "Request sent!",
      successText: "Thank you. We'll get back to you shortly to study your situation.",
      errorGeneric: "An error occurred. Please try again.",
    },
    cookies: {
      title: "We respect your privacy",
      text: "We use cookies necessary for the site to work and, with your consent, audience-measurement and marketing cookies. No non-essential tracker is set without your consent.",
      acceptAll: "Accept all",
      rejectAll: "Reject all",
      customize: "Customize",
      save: "Save my choices",
      necessary: "Necessary",
      necessaryDesc: "Essential for the site to work. Always active.",
      analytics: "Audience measurement",
      analyticsDesc: "Help us understand site usage anonymously.",
      marketing: "Marketing",
      marketingDesc: "Enable advertising content and measurement.",
      always: "Always active",
      policyLink: "Cookie policy",
    },
    calendly: {
      title: "Book an appointment",
      text: "Choose a time that suits you. First conversation without commitment.",
      notConfigured: "Online booking will be available soon. In the meantime, contact us directly.",
      fallback: "Open in a new window",
      needConsent: "The booking calendar uses a third-party service (Calendly). Allow marketing cookies to display it here, or open it in a new window.",
      allowAndLoad: "Allow and display",
    },
    whatsapp: {
      label: "Contact NEKASSUR on WhatsApp",
      prefill: "Hello NEKASSUR, I would like to discuss my insurance.",
      notConfigured: "WhatsApp number to be configured.",
    },
    notFound: {
      title: "Page not found",
      text: "The page you are looking for does not exist or has been moved.",
      cta: "Back to home",
      suggestionsTitle: "Maybe you were looking for:",
    },
    legalCommon: {
      lastUpdate: "Last updated",
      toComplete: "TO BE COMPLETED",
      toCompleteNote: "This information must be filled in before publication.",
    },
  },
};
